<script>
import Label from './Label.vue'

export default {
    props: {
        item_key: {
        type: String,
        required: true,
        },
        item_value: {
        type: String,
        required: false,
        },
        item: {
        type: Object,
        required: true,
        },
        submitted: {
        type: Boolean,
        required: true,
        },
        validation: {
        type: Object,
        required: true,
        },
        updateValue: {
            type: Function,
            required: true
        },
        selectedItem: {
        type: Object,
        required: false
        },
    },
    components: {
        Label
    },
    data() {
        return {
            value: this.item_value
        };
    },
    watch: {
        item_value: {
            handler(val) {
                this.value = val;
            },
            deep: true
        },
        value(val) {
            this.updateValue(this.item_key, val);
        }
    }
};
</script>
<template>
    <div class="mb-3">
        <Label :item="item"/>
        <input
            v-model="value"
            type="date"
            class="form-control"
            :class="{ 'is-invalid': submitted && validation.$error, 'bg-soft-secondary': this.$route.params.categoryName == 'globalupdate' ? false 
            : selectedItem && selectedItem.additionalProp1 && selectedItem.additionalProp1.global ? true : false }"
            :disabled="this.$route.params.categoryName == 'globalupdate' ? false 
            : selectedItem && selectedItem.additionalProp1 && selectedItem.additionalProp1.global ? true : false" 
            :placeholder="item.placeholder"
        />
        <div v-if="submitted && validation.$error" class="invalid-feedback">
        <span v-if="!validation.required">This value is required.</span>
        </div>
    </div>
</template>